const typographyTablesActions = {
  clearFilter: 'Clear',
  noResults: 'no results found'
};

export default typographyTablesActions;
